import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list",
  "use": "list-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"list\">\n  <g fill=\"currentColor\" fill-rule=\"nonzero\">\n    <rect width=\"42\" height=\"6\" x=\"11\" y=\"11\" rx=\"2\" />\n    <rect width=\"42\" height=\"6\" x=\"11\" y=\"23\" rx=\"2\" />\n    <rect width=\"42\" height=\"6\" x=\"11\" y=\"35\" rx=\"2\" />\n    <rect width=\"42\" height=\"6\" x=\"11\" y=\"47\" rx=\"2\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol